<template>
  <input v-model="model" class="website-input" name="website-name" />
</template>

<script setup lang="ts">
const model = defineModel<string>({ required: true });
</script>

<style src="./SharedBaseHoneypot.scss" lang="scss" scoped />
